<template>
  <BaseButton @click="$emit('click')" :disabled="disabled" :type="-1" class="button-upload" :style="style">
    <div class="text">{{lang.text}}</div>
  </BaseButton>
</template>

<script>
import _ from 'lodash'
import { props } from './BaseButton.js'
import BaseButton from './BaseButton.vue'
export default {
  components: { BaseButton },
  props: _.merge({}, props, {
    lang: {
      type: Object,
      default () {
        return {
          text: '点击上传LOGO'
        }
      }
    },
    src: {
      type: String
    }
  }),
  computed: {
    style () {
      if (this.src) {
        return `background-image: url('${this.src}');background-size: cover;`
      }
      return `background-size: 50px;background-image: url('http://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_icon_case_logo.png');`
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.button-upload {
  background-color: var(--colorWhite1);
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: 35%;
  padding: 0;
  color: var(--color7);
  border: 1px solid var(--color8);

  @media (--mediaPc) {
    border-radius: var(--button1BorderRadius);
  }
  @media (--mediaMobile) {
    border-radius: var(--button1BorderRadiusMobile);
  }
  & .text {
    margin-top: 50px;
    @media (--mediaPc) {
      font-size: var(--textSize5);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize5Mobile);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/button/UploadButton.vue